import React, { useState } from "react";
import { Link } from "react-router-dom";
import blogs from "../data/blogs";

export default function BlogList() {
  return (
    <div className="py-10 px-6 max-w-5xl mx-auto">
      <h1 className="text-3xl font-bold text-green-700 mb-6 text-center">
        Our Blog
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {blogs.map((blog) => (
          <BlogCard key={blog.id} blog={blog} />
        ))}
      </div>
    </div>
  );
}

function BlogCard({ blog }) {
  const [imgSrc, setImgSrc] = useState(blog.image || "/images/placeholder.webp");

  return (
    <div className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-200">
      <img
        src={imgSrc}
        alt={blog.title}
        loading="lazy"
        className="w-full h-48 object-cover"
        onError={() => setImgSrc("/images/placeholder.webp")}
      />
      <div className="p-4">
        <h2 className="text-xl font-semibold text-green-700 mb-2">{blog.title}</h2>
        <p className="text-gray-600 text-sm mb-2">{blog.date}</p>
        <p className="text-gray-700 mb-4">{blog.summary}</p>
        <Link
          to={`/blog/${blog.id}`}
          className="text-green-600 font-semibold hover:underline"
        >
          Read More →
        </Link>
      </div>
    </div>
  );
}
